<template>
  <div>
    <el-dialog
      :center="true"
      :visible.sync="show"
      :close-on-click-modal="false"
      :modal="true"
      width="auto"
      height="auto"
      :append-to-body="true"
      class="dialog"
    >
      <div class="box">
        <div class="b_head">
          <span>{{ lang.export }}</span>
          <svg
            @click="close()"
            t="1748587270371"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="5023"
            width="200"
            height="200"
          >
            <path
              d="M0 0h1024v1024H0z"
              fill="#FF0033"
              fill-opacity="0"
              p-id="5024"
            ></path>
            <path
              d="M240.448 168l2.346667 2.154667 289.92 289.941333 279.253333-279.253333a42.666667 42.666667 0 0 1 62.506667 58.026666l-2.133334 2.346667-279.296 279.210667 279.274667 279.253333a42.666667 42.666667 0 0 1-58.005333 62.528l-2.346667-2.176-279.253333-279.253333-289.92 289.962666a42.666667 42.666667 0 0 1-62.506667-58.005333l2.154667-2.346667 289.941333-289.962666-289.92-289.92a42.666667 42.666667 0 0 1 57.984-62.506667z"
              fill="#111111"
              p-id="5025"
            ></path>
          </svg>
        </div>
        <div class="b_main" v-loading="loading">
          <div class="b_m_title">{{lang.selectContent}}</div>
          <div class="b_m_content">
            <el-checkbox v-model="checkList[0]">{{lang.overviewOfProgress}}</el-checkbox>
            <el-checkbox v-model="checkList[1]">{{lang.difficultProblems}}</el-checkbox>
            <el-checkbox v-model="checkList[2]">{{lang.abilityStratification}}</el-checkbox>
            <el-checkbox v-model="checkList[3]">{{lang.teachingSuggestions}}</el-checkbox>
          </div>
        </div>
        <div class="b_bottom">
          <el-button size="small" @click="close()">{{
            lang.cancel
          }}</el-button>
          <el-button size="small" type="primary" @click="submit()">{{
            lang.queding
          }}</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    tid: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      loading: false,
      show: false,
      data: null,
      checkList:[true,true,true,true]
    };
  },
  computed: {},
  methods: {
    async open() {
      // this.data = JSON.parse(JSON.stringify(data));
      this.show = true;
      this.loading = false;
    },
    close() {
      this.show = false;
      this.init();
    },
    init() {
      this.data = null;
      this.loading = false;
    },
    submit(){
      let promise = []

      this.loading = true;
      this.checkList.forEach((b,i)=>{
        if(b){
          if(i==0){
            promise.push(this.$parent.getOverviewOfProgressImg());
          }else if(i==1){
            promise.push(this.$parent.getDifficultProblemsImg());
          }else if(i==2){
            promise.push(this.$parent.getAbilityStratificationImg());
          }else if(i==3){
            promise.push(this.$parent.getTeachingSuggestionsImg());
          }
        }
      })
      Promise.all(promise).then(async (res) => {
        try {
          const jsPDFModule = await import('jspdf');
          const jsPDF = jsPDFModule.default || jsPDFModule.jsPDF || jsPDFModule;

          const pdf = new jsPDF({
            unit: 'mm',
            format: 'a4',
            orientation: 'portrait'
          });

          const pageWidth = 210;
          const pageHeight = 297;
          const distanceBetweenImgs = 8; // 图片之间留白距离（单位：mm）
          const pageMargin = 10; // 页边距
          let added = false;

          // 处理所有图片加载，确保获取原始尺寸再绘制pdf，防止拉伸
          const imagePromises = res.map((imgData) => {
            return new Promise((resolve) => {
              if (!imgData) return resolve(null);
              const img = new window.Image();
              img.onload = function () {
                resolve({
                  imgData: imgData,
                  width: img.naturalWidth,
                  height: img.naturalHeight
                });
              };
              img.onerror = function () {
                resolve(null);
              };
              img.src = imgData;
            });
          });

          const imagesInfo = (await Promise.all(imagePromises)).filter(Boolean); // filter无效图片
          
          let y = pageMargin; // 当前y位移，起始留白
          let isFirstImage = true;
          let pxPerMm = 96 / 25.4; // 图片像素转mm

          if (imagesInfo.length === 0) {
            this.$message.error(this.lang.noExportableImageContent);
            return;
          }

          imagesInfo.forEach((imgInfo) => {
            if (!imgInfo) return;

            let { imgData, width, height } = imgInfo;

            let imgWidthMm = width / pxPerMm;
            let imgHeightMm = height / pxPerMm;

            // 设置最大可渲染宽高
            let maxRenderWidth = pageWidth - pageMargin * 2;
            let maxRenderHeight = pageHeight - pageMargin * 2;

            // 按比例缩小，使图片宽/高都不超A4绘制区
            let ratio = Math.min(maxRenderWidth / imgWidthMm, maxRenderHeight / imgHeightMm, 1);
            let renderWidth = imgWidthMm * ratio;
            let renderHeight = imgHeightMm * ratio;

            // 如果前面不是第一页的第一张，要加距离
            if (!isFirstImage) {
              y += distanceBetweenImgs;
            } else {
              isFirstImage = false;
            }

            // 如果当前剩余空间不够放下图片，就新起一页并重置y
            if (y + renderHeight > pageHeight - pageMargin) {
              pdf.addPage();
              y = pageMargin;
            }

            // 居中
            let x = (pageWidth - renderWidth) / 2;

            pdf.addImage(
              imgData,
              'PNG',
              x,
              y,
              renderWidth,
              renderHeight
            );
            added = true;

            // 下一个将从y坐标继续排
            y += renderHeight;
          });

          if (added) {
            pdf.save(`${this.lang.teachingSpaceAnalysis}.pdf`);
            this.$message.success(this.lang.exportSuccess)
          } else {
            this.$message.error(this.lang.noExportableImageContent);
          }
        } catch (e) {
          console.error('导出PDF失败:', e);
          this.$message.error(this.lang.exportPdfFail);
        }
      }).finally(() => {
        this.loading = false;
      });
    }
  },
};
</script>

<style scoped>
.dialog >>> .el-dialog {
  width: 600px !important;
  border-radius: 8px;
  padding: 0;
  background-color: #fff;
  overflow: hidden;
}

.dialog >>> .el-dialog__body {
  width: 600px !important;
  height: auto;
  flex-shrink: 0;
  padding: 0;
  box-sizing: border-box;
  overflow: auto;
}

.dialog >>> .el-dialog__header {
  display: none !important;
}

.box {
  width: 600px;
  height: auto;
  background: #fafafa;
  border-radius: 15px;
  box-shadow: 0px 6px 30px 5px rgba(0, 0, 0, 0.05),
    0px 16px 24px 2px rgba(0, 0, 0, 0.04), 0px 8px 10px -5px rgba(0, 0, 0, 0.08);
}

.b_head {
  width: 100%;
  height: 50px;
  border-radius: 15px 15px 0 0;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 0 20px;
}

.b_head > span {
  font-size: 18px;
  font-weight: bold;
  color: #000;
}

.b_head > img {
  width: 20px;
  height: 20px;
  cursor: pointer;
}

.b_head > svg {
  width: 20px;
  height: 20px;
  cursor: pointer;
}

.b_main {
  width: 100%;
  height: 100px;
  background: #fafafa;
  padding: 20px 20px 0 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  
}

.b_bottom {
  width: 100%;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  box-sizing: border-box;
  padding: 0 20px;
}


.b_m_title{
  color: rgba(29, 33, 41, 1);
  font-size: 18px;
  margin-bottom: 20px;
  font-weight: 500;
}

.b_m_content{
  font-size: 18px;
  color: rgba(29, 33, 41, 1);
  font-weight: 500;
}
</style>
